
import axios from "axios";
import { TokenType } from "../../models/TokenType";

const BASE_URL = process.env.REACT_APP_BASE_URL_API + '/api-security/v2/token';

const SecurityService = {
  authenticate: async (password: string): Promise<TokenType> => {
    const body = `username=token_temporal&password=${encodeURIComponent(
        password
      )}&grant_type=password&scope=BANKREADER`;
    const response = await axios.post(BASE_URL, body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": `Basic ${process.env.REACT_APP_CLIENT_SECRET}`,
      },
    });
    return response.data.data;
  },
};

export default SecurityService;